module.exports = __webpack_public_path__ + "static/np-plan2-3fad1dcb91d69fa37026f545520832ca.pdf";